import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

import type { SpaceSuggestionsProps } from '../src/SpaceSuggestions.tsx';

export const SpaceSuggestionsLoader: LoadableType<Omit<SpaceSuggestionsProps, 'flags'>> =
	LoadablePaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-SpaceSuggestions" */ '../src/SpaceSuggestions.tsx'
				)
			).SpaceSuggestions,
	});
